import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { AlertCircle, Trash2, X } from "lucide-react";
import { useLanguage } from "../../LanguageProvider";
import "../../styles/components/modal.css";

export const ConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText, 
  cancelText,
  type = "danger", // danger, warning, info
  icon
}) => {
  const { t } = useLanguage();
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="modal-overlay-wrapper">
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="modal-backdrop"
            onClick={onClose}
          />
          <div className="modal-container">
            <motion.div 
              initial={{ scale: 0.9, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 20 }}
              transition={{ type: "spring", damping: 25, stiffness: 300 }}
              className={`confirm-modal ${type}`}
            >
              <button className="modal-close-btn" onClick={onClose}>
                <X size={20} />
              </button>
              
              <div className="modal-header-icon">
                {icon ? icon : (
                  type === "danger" ? <Trash2 size={32} /> : <AlertCircle size={32} />
                )}
              </div>
              
              <div className="modal-content-area">
                <h2 className="modal-title">{title}</h2>
                <p className="modal-message">{message}</p>
              </div>
              
              <div className="modal-actions-horizontal">
                <button 
                  className="modal-btn-secondary" 
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onClose();
                  }}
                >
                  {cancelText || t("cancel")}
                </button>
                <button 
                  className={`modal-btn-primary ${type}`} 
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onConfirm();
                    onClose();
                  }}
                >
                  {confirmText || t("delete")}
                </button>
              </div>
            </motion.div>
          </div>
        </div>
      )}
    </AnimatePresence>
  );
};
